import SSHRef from "@core-components/links/HRef";
import { EExternalRoutes } from "@core-types/routes.enum";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";

const HelpCenterDiscordLink = () => {
  const { locationUrlBuilder } = useAppLanguage();
  const { t } = useAppTranslation("pages.helpCenter");

  return (
    <SSHRef href={locationUrlBuilder(EExternalRoutes.DISCORD)}>
      {t("common.discordServer")}
    </SSHRef>
  );
};

export default HelpCenterDiscordLink;
